
import React, { useRef, useEffect } from 'react';

const usePrevious = <T extends unknown>(value: T): React.MutableRefObject<T>['current'] => {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
};

export default usePrevious;
